import React from 'react';
import classNames from 'classnames';

import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import { FittedImage } from '../../../components';

import css from './ClassDetail.module.css';

const IconShare = () => (
  <svg className={css.heroShareIcon} viewBox="0 0 24 24" role="none">
    <circle cx="6" cy="12" r="3" fill="none" strokeWidth="2" />
    <circle cx="18" cy="6" r="3" fill="none" strokeWidth="2" />
    <circle cx="18" cy="18" r="3" fill="none" strokeWidth="2" />
    <path d="m8.7 10.7 6.6-3.4M8.7 13.3l6.6 3.4" fill="none" strokeWidth="2" />
  </svg>
);

/**
 * The compact hero image of the class detail card (client ask: small hero, and NO uploaded photo
 * is ever cropped anywhere) -- the shared FittedImage treatment: whole photo contained + centered
 * over a blurred self-backdrop, in the fixed compact box. Sits beside the header from the medium
 * viewport (see ClassDetailBody's heroRow). `fullBleed` is the cover-photo Console variant
 * (rounding only). The image (and the photo-count pill) opens the shared image-carousel modal;
 * the share button opens the share modal. The mockup's favorite heart is intentionally absent.
 */
const ClassHero = props => {
  const { listing, fullBleed, onOpenGallery, onOpenShare } = props;
  const intl = useIntl();
  const images = listing.images || [];
  const firstImage = images[0] || null;

  if (!firstImage) {
    return null;
  }

  return (
    <div className={classNames(css.hero, { [css.heroFullBleed]: fullBleed })}>
      <button type="button" className={css.heroImageButton} onClick={onOpenGallery}>
        <FittedImage
          image={firstImage}
          alt={listing.attributes?.title || ''}
          // Matches the COMPACT box's real rendered width. NOTE: this was 736px when the hero
          // spanned the full ~1360px content width -- the browser fetched a ~768-1024px image and
          // stretched it ~1.5-1.8x on 1x desktops, which was a real (self-inflicted) source of the
          // reported pixelation.
          sizes="(max-width: 767px) 100vw, 340px"
        />
        {images.length > 1 ? (
          <span className={css.heroPhotoCount}>
            <FormattedMessage id="ClassDetailPage.photoCount" values={{ count: images.length }} />
          </span>
        ) : null}
      </button>
      {onOpenShare ? (
        <button
          type="button"
          className={css.heroShare}
          onClick={onOpenShare}
          aria-label={intl.formatMessage({ id: 'ClassDetailPage.shareButtonLabel' })}
        >
          <IconShare />
        </button>
      ) : null}
    </div>
  );
};

export default ClassHero;
